import { useLingui } from '@lingui/react/macro';
import { ShieldCross } from 'iconsax-reactjs';
import type { FC } from 'react';
import { useHasAccessToken } from '@/auth/api';
import { Link, Redirect } from '@/base/router';
import { Button } from '@/shared/Button';

export const ShowLoginFallback: FC = () => {
  const { t } = useLingui();

  return (
    <div className="flex flex-col items-center gap-2">
      <p className="text-base">{t`You need to login to view this content.`}</p>
      <Link workspace="app" to="/auth" className="contents">
        <Button size={10} variant="brand">
          {t`Login`}
        </Button>
      </Link>
    </div>
  );
};

export const IdentifyFallback: FC = () => {
  const { t } = useLingui();
  const hasAccessToken = useHasAccessToken();
  if (!hasAccessToken) {
    return <ShowLoginFallback />;
  }

  return (
    <div className="flex flex-col items-center justify-center text-center py-16 gap-4">
      <ShieldCross size={64} className="text-content-tertiary" />
      <h2 className="text-xl font-bold">{t`Identity Verification Required`}</h2>
      <p className="text-sm text-content-secondary max-w-md">
        {t`To use this feature, you need to complete your identity verification (Level 3). This helps keep all traders safe and secure.`}
      </p>
      <Link workspace="app" to="/account/identification">
        <Button variant="brand" size={10}>
          {t`Complete Verification`}
        </Button>
      </Link>
    </div>
  );
};

export const RedirectToDashboardFallback: FC = () => {
  return <Redirect workspace="app" to="/dashboard" />;
};
